import React from 'react';
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Icon,
  Flex,
  Text,
} from '@wegroup/design-system';
import {
  setShownProductsOrder,
  ShownProductOrder,
} from '../../../../../store/redux/slices/offersSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../../../store/redux/reducers/rootReducer';

const OffersOrderButton: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const shownProducts = useSelector(
    (state: RootState) => state.offers.shownProducts,
  );
  const shownProductsOrder = useSelector(
    (state: RootState) => state.offers.shownProductsOrder,
  );
  const options: ShownProductOrder[] = ['PRICE_ASC'];
  const withQuality = shownProducts?.some(({ quality }) => !!quality);

  if (withQuality) {
    options.push('QUALITY_DESC');
  }

  const handleChange = (value?: ShownProductOrder) => {
    dispatch(setShownProductsOrder(value));
  };

  return (
    <Flex justify="flex-end" mb="4">
      <Menu isLazy placement="bottom-end">
        <MenuButton
          as={Button}
          borderRadius="full"
          variant="secondary"
          isDisabled={!shownProducts?.length}
          rightIcon={<Icon name="GeneralActionsChevronDown" boxSize={5} />}
        >
          <Text as="span" fontWeight="normal" color="gray.500">
            {t('OFFERS_OVERVIEW_HEADER_ORDER-BUTTON_SORT-BY')}:{' '}
          </Text>{' '}
          {shownProductsOrder
            ? t(`OFFERS_OVERVIEW_HEADER_ORDER-BUTTON_${shownProductsOrder}`)
            : ''}
        </MenuButton>
        <MenuList zIndex="2">
          {/* {!withQuality && (
            <MenuItem onClick={() => handleChange(undefined)}>-</MenuItem>
          )} */}
          {options.map((value) => (
            <MenuItem
              key={value}
              onClick={() => handleChange(value)}
              bg={value === shownProductsOrder ? 'gray.ultraLight' : undefined}
            >
              {t(`OFFERS_OVERVIEW_HEADER_ORDER-BUTTON_${value}`)}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </Flex>
  );
};

export default OffersOrderButton;
